import { Button, Form, Input } from 'antd';
import { validateEmail } from '../../Validators/ValidatorEmail';
import type { ReactNode } from 'react';
import { useState } from 'react';
import { t } from 'i18next';

interface EmailListFormComponentProps {
  propertyReference: string;
  parentReference: Array<string | number>;
  buttonTitle: string;
  emailType: string;
}

export const EmailListFormComponent = ({
  propertyReference,
  parentReference,
  buttonTitle,
  emailType,
}: EmailListFormComponentProps): ReactNode => {
  const [emails, setEmails] = useState<Array<string>>([]);

  return (
    <Form.List name={[...parentReference, propertyReference]}>
      {(fields, fieldOperations) => (
        <>
          {fields.map((field) => (
            <Form.Item
              key={field.key}
              name={[field.name]}
              rules={[
                { required: true },
                { validator: validateEmail },
                {
                  validator: (_rule, value): Promise<void> => {
                    return emails.filter((email) => email === value).length ===
                      1
                      ? Promise.resolve()
                      : Promise.reject(t('validator.duplicateEmail'));
                  },
                },
              ]}
            >
              <Input
                onChange={(e) => {
                  setEmails((emails) => {
                    const newState = [...emails];
                    newState[field.name] = e.target.value;
                    return newState;
                  });
                }}
                value={emails[field.name]}
                placeholder={`${emailType} Email`}
              />
            </Form.Item>
          ))}
          <Form.Item
            style={{
              justifySelf: 'center',
            }}
          >
            <Button
              type="primary"
              onClick={() => {
                fieldOperations.add();
                setEmails([...emails, '']);
              }}
            >
              {buttonTitle}
            </Button>
          </Form.Item>
        </>
      )}
    </Form.List>
  );
};
